const HOMOLOG_PROMOTIONS_CATEGORY_ID = '01KPY4SWPNHSH0VCKVJ6C72E37';
const PRODUCTION_PROMOTIONS_CATEGORY_ID = '01KQD3WMCPQ9ST9XD25FHGRPRM';

export function getPromotionsCategoryId(): string {
  if (typeof window === 'undefined') {
    return PRODUCTION_PROMOTIONS_CATEGORY_ID || HOMOLOG_PROMOTIONS_CATEGORY_ID;
  }

  const host = window.location.hostname;

  const mapping = [
    { match: 'localhost', id: HOMOLOG_PROMOTIONS_CATEGORY_ID },
    { match: '127.0.0.1', id: HOMOLOG_PROMOTIONS_CATEGORY_ID },
    {
      match: 'apostatudo-bet-br-homolog',
      id: HOMOLOG_PROMOTIONS_CATEGORY_ID,
    },
    { match: 'apostatudo.bet', id: PRODUCTION_PROMOTIONS_CATEGORY_ID },
  ];

  const entry = mapping.find((env) => host.includes(env.match));

  return entry?.id || HOMOLOG_PROMOTIONS_CATEGORY_ID;
}
